import { ToastService } from 'src/app/services/toast.service';
import { UserService } from 'src/app/services/user.service';
import { UserMenuNodes } from 'src/app/models/user-menu-nodes';
import { GeneralService } from 'src/app/services/general.service';
import { DataService } from "../data-service/data.service.service";
import { AppConfigService } from 'src/app/app-config.service.service';
import { Routes, RouterModule, Router, NavigationEnd } from '@angular/router';
import { MapInformationService } from 'src/app/services/map-information.service';
import { CompanySettingsService } from 'src/app/services/company-settings.service';
import { Component, OnInit, OnDestroy, Input, Output, EventEmitter, ViewChild, HostListener } from '@angular/core';
import { ThemeService } from 'src/app/services/theme.service'
import { VariablesService } from 'src/app/services/variables.service'
import { Observable, Subscription } from 'rxjs';
declare var $: any;

@Component({
    selector: 'app-navbar-sidebar',
    templateUrl: './navbar-sidebar.component.html',
    styleUrls: ['./navbar-sidebar.component.scss'],
    standalone: false
})
export class NavbarSidebarComponent implements OnInit, OnDestroy {
  themeName: string = 'orange-theme'
  popupLayouThemes = false;
  emailList: any;
  emailPopup = false;
  plusSiteButton: any;
  plusSubjectemailButton: any;
  cancelButtonPopupemail: any;
  cleanButtonPopupemail: any;
  sendButtonPopupemail: any;
  updatetemplateButtonPopupemail: any;
  popupVisibleTemplates: boolean;
  isMultiline = false;
  toolbarButtonOptions :any = {
     icon: 'fas fa-layer-group',
     stylingMode: 'text',
     hint:"Templates",
     onClick: () => this.popupVisibleTemplates = true,
   };

  popupSettings2 = false;
  PopupTerms = false;

  defaultVisible: boolean;
  withTitleVisible: boolean;
  withAnimationOptionsVisible: boolean;
  withShadingOptionsVisible: boolean;

  name = '';
  isSideBarVisible = true;
  userNemu: any;
  menu: any;
  currentactiveComponents: any;
  userName: string;
  options: any;

  currentUserId = localStorage.getItem('customerid');
  userSetting: any = { lat: 0, long: 0, geoname: '' };
  currentUserCompanyId: number = 0;

  // @Input() userName: string;
  languageSelect: Array<any> = [];
  currencySelect: Array<any> = [];
  timeformSelect: Array<any>;
  timezoneSelect: Array<any> = [];
  startpageSelect: Array<any> = [];
  sesiontimeSelect: Array<any>;
  dateformSelect: Array<any> = [];
  UserCompanyName: string;

  customer: any;
  savingUserSetting = false;
  message: any;
  isNavCollapse = false;
  typeSupport = [];
  currentUrl = '';
  @Output() navCollapseOut: EventEmitter<any> = new EventEmitter<any>();
  @Output() outputVisibleNav: EventEmitter<any> = new EventEmitter<any>();

  modelChangePassword = {
    pass_current: '',
    pass: '',
    confirmPass: ''
  };

  popupTask = false;
  popupEmployeeActivity = false;
  popupCustomer = false;
  popupNewContact = false;
  popupCreateSalesProject = false;
  popupSWOClient = false;
  popupNewRFI = false;
  popupPunchList = false;
  popupProgressReport = false;

  LinkGettingStarted: string;
  LinkCubeFlow: string;
  LinkWhatsNew: string;
  dashboardURL: string;

// VARIABLES ALARMAS

  PopupAlarm: boolean = false;
  PopupChangeCompany: boolean = false;
  PhasesAlarm: any[] = [];
  customOperations: Array<any>;
  popupPosition: any;
  TotalAlarms:number=0;
  enablePopupWorkFlowAlarm:boolean = false;
  enablePopupCompaniewAlarm:boolean = false;

  cancelButtonTasK: any;
  saveButtonTasK: any;
  saveNewButtonTasK: any;
  saveEditButtonTasK: any;
  @ViewChild('newtask') newtask: any;

  cancelButtonNewEmployee: any;
  saveButtonNewEmployee: any;
  saveNewButtonNewEmployee: any;
  saveEditButtonNewEmployee: any;
  @ViewChild('newActivity') newActivity: any;

  cancelButtonNewCustomer: any;
  saveButtonNewCustomer: any;
  saveNewButtonNewCustomer: any;
  saveEditButtonNewCustomer: any;
  @ViewChild('newcustomer') newcustomer: any;

  cancelButtonNewSales: any;
  saveButtonNewSales: any;
  saveNewButtonNewSales: any;
  saveEditButtonNewSales: any;
  @ViewChild('componentSales') componentSales: any;

  products: any;
  product: number;
  searchModeOption: string = "contains";
  searchExprOption: any = "NAME";
  searchTimeoutOption: number = 200;
  minSearchLengthOption: number = 0;
  showDataBeforeSearchOption: boolean = false;
  clients: any = [];

  template = {
    id: 0,
    text: '',
    active: 1,
    subject: '',
    createdate: '',
    updateddate: '',
    updatedbyid: '',
    tag: '',
    metadata: '',
    method: 'InsertUpdateNotificationEmailTemplate'
  };

  acceptterm: string = "0";

  arrayTemplate: any;
  allTemplate: any;

detailEmail:any = [];
  selectionModeValueList = 'multiple';
  emailCategory: any;
   selectionModeValue = 'single';
   selectAllModeVlaue = 'page';


  numberCart:number = 0
  logged: boolean;
  showLoginModal: boolean=false;
  private startPagesRequested = false;

  userName$: Observable<string>;
  buttonPassword: { icon: any; type: string; hint: any; onClick: () => void; };
  buttonPassword1: { icon: any; type: string; hint: any; onClick: () => void; };
  buttonPassword2: { icon: any; type: string; hint: any; onClick: () => void; };
  iconButtonPassword = 'fas fa-eye';
  hintButtonPassword: any;
  showPassword = false
  password = 'password';
  showPassword1 = false;
  password1 = 'password';
  showPassword2 = false;
  password2 = 'password';
  popupChangePass: boolean;
  ecomerceconcode: any;
  base64Logo: any;
  private logoSub: Subscription;

  // ── Shell CUBE Edge (barra superior de marca con el menu adentro) ──
  // Modulos del portal (los mismos 4 links que tenia el navbar viejo)
  menuItems = [
    { route: 'cs-portal',            label: 'Dashboard',          icon: 'fas fa-th-large' },
    { route: 'cs-serviceWorkOrder',  label: 'Service Work Order', icon: 'fas fa-clipboard-list' },
    { route: 'cs-serviceSite',       label: 'Service Sites',      icon: 'fas fa-building' },
    { route: 'cs-serviceSiteAssets', label: 'Assets Management',  icon: 'fas fa-cubes' },
  ];
  userMenuOpen = false;

  constructor(
    private router: Router,
    private data: DataService,
    private toast: ToastService,
    public  userService: UserService,
    private appsettings: AppConfigService,
    private generalService: GeneralService,
    public settingsCompany: CompanySettingsService,
    public apiConfig: AppConfigService,
    public ThemeService: ThemeService,
    private MapInformationService: MapInformationService,
    public VariablesService: VariablesService) {


      this.userName$ = this.VariablesService.userName$
      this.ecomerceconcode = this.apiConfig.ecomerceconcode;

      // if (localStorage.getItem('token') != undefined){
      //   this.logged = true
      // } else {
      //   this.logged = false
      // }


      this.detailEmail =[  {
        ID: 1,
        CompanyName: 'Super Mart of the West',
        Address: '702 SW 8th Street',
        City: 'Bentonville',
        State: 'Arkansas',
        Zipcode: 72716,
        Phone: '(800) 555-2797',
        Fax: '(800) 555-2171',
        Website: 'http://www.nowebsitesupermart.com',
        }];

  this.emailCategory =  [
    {
    ID: 1,
    Name: 'Incoming',

    },
    {
    ID: 2,
    Name: 'Outgoing',
    },
    {
    ID: 3,
    Name: 'Draft',
    },
    {
    ID: 4,
    Name: 'Delete',
    }
  ];

    this.emailList =  [{
      key: '2022/01/04',
      items: ['Choose between PPO and HMO Health Plan',
              'Google AdWords Strategy',
              'New Brochures',
              'Update NDA Agreement',
              'Review Product Recall Report by Engineering Team',
              'Review Product Recall Report by Engineering Team',
              'Review Product Recall Report by Engineering Team',
              'Review Product Recall Report by Engineering Team',
              'Choose between PPO and HMO Health Plan',
              'Google AdWords Strategy',
              'New Brochures',
              'Update NDA Agreement',
              'Review Product Recall Report by Engineering Team',
              'Review Product Recall Report by Engineering Team',
              'Review Product Recall Report by Engineering Team',
              'Review Product Recall Report by Engineering Team'

            ]
      }
    ];

      this.arrayTemplate = [{

        key: 'Create Templates',
        items: [{subject: 'Save as new template'}],
      },
      {
        key: 'Custom Template',
        items: [],
      }
    ];

      //modales
      this.plusSiteButton = {
        icon: "fas fa-bullhorn",
        type: "button",
        onClick: () => {

        }
      };

      this.plusSubjectemailButton = {
        icon: "fas fa-paperclip",
        type: "button",
        elementAttr: {
          id: 'c-green'
        },
        onClick: () => {

        }
      };

      this.cancelButtonPopupemail = {
        text: 'Cancel',
        elementAttr: {
          id: 'bton-gray'
        },
        onClick: () => {
            this.emailPopup = false;
            this.clearTemplate()
            this.deleteUpdateTemplate()
        },
      };

      this.cleanButtonPopupemail = {
        text: 'Clear Template',
        elementAttr: {
          id: 'bton-gray'
        },
        onClick: () => {
          this.clearTemplate()
        },
      };

      this.sendButtonPopupemail = {
        text: 'Send',
        icon: 'check',
        elementAttr: {
          id: 'bton-green'
        },
        onClick: () => {

        },
      };

      // this.updatetemplateButtonPopupemail = {
      //   text: 'Update template',
      //   elementAttr: {
      //     id: 'bton-green'
      //   },
      //   onClick: () => {
      //     this.saveTemplate()
      //   },
      // };



    this.defaultVisible = false;
    this.withTitleVisible = false;
    this.withAnimationOptionsVisible = false;
    this.withShadingOptionsVisible = false;

    let settings = {
      dateFormat: this.appsettings.dateFormat,
      moneyFormat: this.appsettings.moneyFormat,
      startPage: ''
    }

    this.LinkGettingStarted = this.appsettings.LinkGettingStarted;
    this.LinkCubeFlow = this.appsettings.LinkCubeFlow;
    this.LinkWhatsNew = this.appsettings.LinkWhatsNew;
    this.dashboardURL = this.appsettings.dashboardURL;

    this.userService.settings.next(settings);


    this.userNemu = [];
    const isclient = localStorage.getItem('isClient');
    if (isclient) {
      this.userService.isClient.next(JSON.parse(isclient.toLocaleLowerCase()));
    }

    this.currencySelect = this.appsettings.currencyData;
    this.dateformSelect = this.appsettings.dateFormatData;

    // sessionStorage.setItem('moduleId', '15');


  }
  bind(getCartInfo: (info: any) => void) {
    throw new Error('Method not implemented.');
  }

  changeStartPage(obj) {
    // this.userSettings.startPage = obj.selectedItem.NCUBELINK;
  }
  goTraining() {
    this.router.navigateByUrl('/Training');
  }

  cancelButtonEmail() {
    this.emailPopup = false;
    this.clearTemplate();
    this.deleteUpdateTemplate();
  };


  onCompanyChanged (e) {
    this.currentUserCompanyId = e.value;
  }

  getString(obj){
    return JSON.stringify(obj)
  }

  updateDefaultCompany(){

    this.PopupChangeCompany = false;

    this.userService.UpdateUserDefaultClient(this.currentUserCompanyId).subscribe(result => {
      localStorage.setItem('autoStart', '1');
      this.router.navigateByUrl('/applications');
    });

  }

  NavCubeShop(to){
    console.log(to)
    this.router.navigate([`/${to}`])
  }

  NavCube(to){
    this.router.navigate([`/${to}`])
  }

  // pestaña activa del menu: la ruta actual empieza con la del modulo
  isActive(route: string): boolean {
    const url = (this.router.url || '').split('?')[0];
    return url === '/' + route || url.startsWith('/' + route + '/');
  }

  // logo propio de la empresa (white-label, llega en base64 desde el login); si no hay, la marca de CUBE
  get hasCompanyLogo(): boolean {
    return typeof this.base64Logo === 'string' && this.base64Logo.startsWith('data:');
  }

  get userInitials(): string {
    const parts = (this.userName || '').trim().split(/\s+/).filter(p => p);
    if (!parts.length) { return '?'; }
    return ((parts[0][0] || '') + (parts.length > 1 ? parts[parts.length - 1][0] : '')).toUpperCase();
  }

  get userEmail(): string {
    return localStorage.getItem('email') || '';
  }

  /* Cierra el menu de usuario al clickear afuera. click Y mousedown: varios widgets de DevExtreme
     cortan la propagacion del click. UN solo @HostListener por evento en esta clase: si se agrega
     otro menu, sumarlo aca (dos @HostListener con el mismo evento se pisan y solo corre uno). */
  @HostListener('document:click', ['$event'])
  @HostListener('document:mousedown', ['$event'])
  cerrarMenuUsuario(ev: any) {
    const t = ev ? ev.target : null;
    if (t && !document.contains(t)) { return; }
    if (this.userMenuOpen && !(t && t.closest && t.closest('.cs-user'))) { this.userMenuOpen = false; }
  }

  @HostListener('document:keydown.escape')
  cerrarMenuConEscape() { this.userMenuOpen = false; }


  modalThemes() {
      this.popupLayouThemes = true;
  }

  ngOnDestroy() {
    if (this.logoSub) { this.logoSub.unsubscribe(); }
  }

  ngOnInit() {
    this.userName = localStorage.getItem('userName');

    this.logoSub = this.ThemeService.imgLogo$.subscribe(logo => {
      this.base64Logo = logo;
    });

    const storedTheme = localStorage.getItem('themeName');
    if (storedTheme) {
      this.themeName = storedTheme;
      this.ThemeService.setTheme(storedTheme); // Aplicar tema almacenado en el servicio
    }

    this.buttonPassword = {
      icon: this.iconButtonPassword,
      type: "button",
      hint: this.hintButtonPassword,
      onClick: () => {
        this.showPassword = !this.showPassword;
        this.password = this.showPassword ? 'text' : 'password';
        this.iconButtonPassword = this.showPassword ? 'fas fa-eye-slash' : 'fas fa-eye';
      }
    }

    this.buttonPassword1 = {
      icon: this.iconButtonPassword,
      type: "button",
      hint: this.hintButtonPassword,
      onClick: () => {
        this.showPassword1 = !this.showPassword1;
        this.password1 = this.showPassword1 ? 'text' : 'password';
        this.iconButtonPassword = this.showPassword1 ? 'fas fa-eye-slash' : 'fas fa-eye';
      }
    }

    this.buttonPassword2 = {
      icon: this.iconButtonPassword,
      type: "button",
      hint: this.hintButtonPassword,
      onClick: () => {
        this.showPassword2 = !this.showPassword2;
        this.password2 = this.showPassword2 ? 'text' : 'password';
        this.iconButtonPassword = this.showPassword2 ? 'fas fa-eye-slash' : 'fas fa-eye';
      }
    }

    this.getTemplatesEmail()

    //let settings = JSON.parse(localStorage.getItem('settings'));
      // this.getUserSetting();
    this.router.events.subscribe(event => {

      this.userName = localStorage.getItem('userName');
      this.UserCompanyName = localStorage.getItem('UserCompanyName');
      this.acceptterm = localStorage.getItem('termaccepted');

      if (this.acceptterm == "0"){
        this.PopupTerms = true;
      }

      // this.isClient = this.userService.isClient.value;

      if (event instanceof NavigationEnd) {
        this.currentUrl = event.url;
        this.name = (<any>event).url.split("/").slice(-1)[0];

        if (this.name == '' || this.name == 'detailsJobs' || this.name == 'myJobs' || this.name == 'offerView' || this.name == 'findWork' || this.name == 'myProposals' || this.name == 'profileTalent' || this.name == 'settings' || this.name == 'reportsWork' || this.name == 'reviewPost' || this.name == 'jobs' || this.name == 'contracts' || this.name == 'jobPost' || this.name == 'clientDashboard' || this.name == 'myFeed' || this.name == 'searchJobs' || this.name == 'myCart' || this.name == 'applications' || this.name == 'yourOrder' || this.name == 'orderDetail' || this.name == 'order' || this.name == 'newShippingAddress' || this.name == 'shippingAddress' || this.name == 'newPayment' || this.name == 'creditcard' || this.name == 'paymentCart' || this.name == 'productsDetails' || this.name == 'productsCart' || this.name == 'productsCategory' || this.name == 'login' || this.name == 'NewAccount' || this.name == 'RecoverPassword' || this.name == 'CompanyRegistration' || this.name == 'Payment' || this.name == 'externaluser' || this.name == 'registerCompany' || this.name == 'companyRegistration'  || this.name == 'payment'  || this.name.indexOf('actPass') > -1 ) {

          this.isSideBarVisible = false;
        }
        else {
          this.isSideBarVisible = true;
          // this.getMenu();
          // Agregado por Evander
          // this.getAlarms()
          // Get UserCompanies
          // this.userService.GetUserClients().subscribe(result => {

          //     this.clients = result;

          // });

          this.currentUserId = localStorage.getItem('customerid');
          if (this.startpageSelect.length == 0 && !this.startPagesRequested) {

            if (this.currentUserId) {
              this.userService.Get_UserSettingsCE(this.currentUserId).subscribe(result => {

                if (result.length > 0 && result[0].CLIENTUSERSETTING) {
                  let obj = JSON.parse(result[0].CLIENTUSERSETTING);

                  localStorage.setItem('settings', result[0].CLIENTUSERSETTING);
                  localStorage.setItem('UserCompanyName', result[0].UserCompanyName);

                  if (obj)
                    this.userService.settings.next(obj);
                }
              }, () => { /* cliente sin configuracion propia: el API responde 500 "no row" */ });


            // settings y paginas de inicio se piden UNA vez (startPagesRequested): si el cliente no
            // tiene filas el API da 500 y antes se volvian a pedir (y a fallar) en cada navegacion
            this.startPagesRequested = true;
            this.userService.Get_ClientUserStartPagesCE().subscribe(result => {
              this.startpageSelect = (result || []).filter(x => x.NCUBELINK != 'NULL');
            }, () => { /* sin paginas de inicio */ });
          }
        }


        }


      }

      if (event.constructor.name === "NavigationEnd") {

      }



      this.outputVisibleNav.emit(this.isSideBarVisible);
    });

    this.typeSupport = [
      { value: 1, label: 'Type Support 1' },
    ];
    this.languageSelect = [
      { value: 1, label: 'Inglés' },
      { value: 2, label: 'Chino mandarín' },
      { value: 3, label: 'Hindi' },
      { value: 4, label: 'Español' },
      { value: 5, label: 'Francés' },
      { value: 6, label: 'Árabe' },
      { value: 7, label: 'Bengalí' },
      { value: 8, label: 'Ruso' },
      { value: 9, label: 'Portugués' },
      { value: 10, label: 'Indonesio' },
      { value: 11, label: 'Urdu' },
      { value: 12, label: 'Alemán' },
      { value: 13, label: 'Japonés' },
      { value: 14, label: 'Panyabí occidental' },
      { value: 15, label: 'Javanés' },
      { value: 16, label: 'Chino Wu' },
      { value: 17, label: 'Telugú' },
      { value: 18, label: 'Turco' },
      { value: 19, label: 'Coreano' },
      { value: 20, label: 'Maratí' },
      { value: 21, label: 'Tamil' },
      { value: 22, label: 'Chino cantonés' },
      { value: 23, label: 'Vietnamita' },
      { value: 24, label: 'Italiano' },
      { value: 25, label: 'Hausa' },
      { value: 26, label: 'Tailandés' },
      { value: 27, label: 'Persa iraní' },
      { value: 28, label: 'Chino Min Nán' },
    ];


    this.timeformSelect = [
      { value: '1', label: '12 Hours' },
      { value: '2', label: '24 Hours' },
    ];

    this.timezoneSelect = [
      { value: '1', label: '(GMT-11:00) International Date Line West' },
      { value: '2', label: '(GMT-11:00) Midway Island' },
      { value: '3', label: '(GMT-04:00) Samoa' },
      { value: '4', label: '(GMT-10:00) Hawaii' },
      { value: '5', label: '(GMT-04:00) Caracas' }

    ];

    // this.startpageSelect = [
    //   { value: '1', label: 'Option 1' },
    //   { value: '2', label: 'Option 2' },
    //   { value: '3', label: 'Option 3' },
    //   { value: '4', label: 'Option 4' },
    //   { value: '5', label: 'Option 5' }

    // ];

    this.sesiontimeSelect = [
      { value: '1', label: '20 Min' },
      { value: '2', label: '30 Min' },
      { value: '3', label: '40 Min' },
      { value: '4', label: '50 Min' },
      { value: '5', label: '60 Min' }

    ];



    const storageMessage = localStorage.getItem('messageNav');
    if (storageMessage) {
      this.message = JSON.parse(storageMessage);
    }

    this.cancelButtonTasK = {
      text: 'Cancel',
      elementAttr: {
        id: 'bton-gray'
      },
      onClick: () => {
        // this.componentSales.ngOnInit();
        this.popupTask = false;
      },
    };

    this.saveButtonTasK = {
      text: 'Save',
      icon: 'check',
      elementAttr: {
        id: 'bton-green'
      },
      onClick: () => {
        // this.type = 1;
        this.newtask.updateTask(false);
      },
    };

    this.saveNewButtonTasK = {
      text: 'Save & New',
      elementAttr: {
        id: 'bton-gray-outline'
      },
      onClick: () => {
        this.newtask.updateTask(true)
      },

    };

    this.saveEditButtonTasK = {
      text: 'Save & Edit',
      elementAttr: {
        id: 'bton-gray-outline'
      },
      onClick: () => {
        this.newtask.updateTask(false, true)
      },

    };


    this.cancelButtonNewEmployee = {
      text: 'Cancel',
      elementAttr: {
        id: 'bton-gray'
      },
      onClick: () => {
        // this.componentSales.ngOnInit();
        this.popupEmployeeActivity = false;
      },
    };

    this.saveButtonNewEmployee = {
      text: 'Save',
      icon: 'check',
      elementAttr: {
        id: 'bton-green'
      },
      onClick: () => {
        // this.type = 1;
        this.newActivity.submitForm(true, false);
      },
    };

    this.saveNewButtonNewEmployee = {
      text: 'Save & New',
      elementAttr: {
        id: 'bton-gray-outline'
      },
      onClick: () => {
        this.newActivity.submitForm(false, false);
      },

    };

    this.saveEditButtonNewEmployee = {
      text: 'Save & Edit',
      elementAttr: {
        id: 'bton-gray-outline'
      },
      onClick: () => {
        this.newActivity.submitForm(true, true);
      },
    };



    this.cancelButtonNewCustomer = {
      text: 'Cancel',
      elementAttr: {
        id: 'bton-gray'
      },
      onClick: () => {
        // this.componentSales.ngOnInit();
        this.popupCustomer = false;
      },
    };

    this.saveButtonNewCustomer = {
      text: 'Save',
      icon: 'check',
      elementAttr: {
        id: 'bton-green'
      },
      onClick: () => {
        // this.type = 1;
        this.newcustomer.submitForm(true, false);
      },
    };

    this.saveNewButtonNewCustomer = {
      text: 'Save & New',
      elementAttr: {
        id: 'bton-gray-outline'
      },
      onClick: () => {
        this.newcustomer.submitForm(false, false);
      },

    };

    this.saveEditButtonNewCustomer = {
      text: 'Save & Edit',
      elementAttr: {
        id: 'bton-gray-outline'
      },
      onClick: () => {
        this.newcustomer.submitForm(true, true);
      },
    };


    this.cancelButtonNewSales = {
      text: 'Cancel',
      elementAttr: {
        id: 'bton-gray'
      },
      onClick: () => {
        this.componentSales.ngOnInit();
        this.popupCreateSalesProject = false;
      },
    };


    this.saveButtonNewSales = {
      text: 'Save',
      icon: 'check',
      elementAttr: {
        id: 'bton-green'
      },
      onClick: () => {
        this.componentSales.updateSalesProject(1);
      },
    };

    this.saveNewButtonNewSales = {
      text: 'Save & New',
      elementAttr: {
        id: 'bton-gray-outline'
      },
      onClick: () => {
        this.componentSales.updateSalesProject(2);
      }
    };

    this.saveEditButtonNewSales = {
      text: 'Save & Edit',
      elementAttr: {
        id: 'bton-gray-outline'
      },
      onClick: () => {
        this.componentSales.updateSalesProject(3);
      }
    };

    // if(localStorage.getItem('customerid') != undefined){
    // }

  }

  getTemplatesEmail(){
    console.log('template ini')
    // this.MapInformationService.getEmailTemplate().subscribe(res => {
    //   console.log(res)
    //   console.log(this.arrayTemplate)
    //   let data = res
    //   let dataTemplate = []
    //   let titleTemplate = []
    //   Array.prototype.forEach.call(data, retorno => {
    //     let tempatePros = {
    //       id: retorno['ID'],
    //       active: retorno['ACTIVE'],
    //       createdate: retorno['CREATEDATE'],
    //       createbyid: retorno['CREATEBYID'],
    //       metadata: retorno['METADATA'],
    //       subject: retorno['SUBJECT'],
    //       tag: retorno['TAG'],
    //       text: retorno['TEXT'],
    //       updatedbyid: retorno['UPDATEDBYID'],
    //       updateddate: retorno['UPDATEDDATE'],
    //       key: 'Custom Template',
    //       method: 'InsertUpdateNotificationEmailTemplate'
    //     }
    //     dataTemplate.push(tempatePros)
    //   })
    //   console.log(titleTemplate)
    //   console.log(dataTemplate)
    //   Array.prototype.forEach.call(this.arrayTemplate, template => {
    //     if(template.key == 'Custom Template'){
    //       console.log(1)
    //       console.log(template.items)
    //       template.items = []
    //       console.log(2)
    //       console.log(template.items)
    //       template.items = dataTemplate
    //       console.log(3)
    //       console.log(template.items)
    //     }
    //   })
    // })
    console.log(this.arrayTemplate)
    console.log('template fin')
  }


  // ************ ALARMA (Parte del codigo agregado por Evander)*************************

  getAlarms() {
    // const data = {
    //   method: "Get_CompanyActiveAlarms"
    // }
    // this.MapInformationService.SaveInfoSites(data)
    //   .subscribe(resp => {
    //     resp.sort(function (a, b) { return a.Department_ID - b.Department_ID })

    //     this.TotalAlarms = resp.length
    //     this.PhasesAlarm = resp
    //   })
  }

  OpenPopupAlarm() {
    this.PopupAlarm = true
  }

  OpenPopupCompany() {
    this.PopupChangeCompany = true
  }

  OpenemailPopup() {
    this.emailPopup = true
  }


  GoToAlarmModal(data){
    switch(data.data.Alarm_Page){
      case "Workflowsummary":
        this.enablePopupWorkFlowAlarm = true
      break
      case "Customer_Activities":
        this.enablePopupCompaniewAlarm = true
      break
    }
  }

// ******************************************


  toggleSide() {
    this.isNavCollapse = !this.isNavCollapse;
    this.navCollapseOut.emit(this.isNavCollapse);
  }

  handleAddressChange(res) {
    this.userSetting.long = res.geometry.location.lng();
    this.userSetting.lat = res.geometry.location.lat();
    this.userSetting.geoname = res.formatted_address;
    localStorage.setItem('currentLat', res.geometry.location.lat().toString())
    localStorage.setItem('currentLong', res.geometry.location.lng().toString())
  }

  logOut() {
    // let settings = localStorage.getItem('settings');
    sessionStorage.clear();
    localStorage.clear();
    this.userService.currentUserName.next('');

    this.router.navigateByUrl('/login');
    this.logged = false

    // localStorage.setItem('settings', settings)
  }

  toggleWithShadingOptions() {
    this.withShadingOptionsVisible = !this.withShadingOptionsVisible;
  }

  limpiarmodalTask() {
    $('#btnlimpiarmodaltask').click();
  }

  onSubmitTask(visibleModal) {
    this.popupTask = visibleModal;
    // this.setGrid2();
  }

  saveUserSettings() {
    this.savingUserSetting = true;
    // this.userService.settings.value.moneyFormat = null;
    localStorage.setItem('settings', JSON.stringify(this.userService.settings.value));
    this.savingUserSetting = false;
    // this.toast.success('Update successful');

    // this.userSetting.userid = this.currentUserId;
    this.userSetting.usersettings = JSON.stringify(this.userService.settings.value);
    // console.log(this.userService.settings.value);
    this.userService.saveUserSettingCoor(this.userSetting).subscribe(result => {
      this.toast.success('Update successful');
      // this.getUserSetting();
    });
    // this.generalService.SaveUserSettings(this.userSettings).subscribe(result => {
    //   this.savingUserSetting = false;
    //   this.toast.success('Update successful');
    // });

  }



  getMenu() {

    // var mythis = this;

    // this.data.currentMessage.subscribe(
    //   // message => this.message = message
    //   function name(message) {
    //     const storageMessage = localStorage.getItem('messageNav');

    //     if (storageMessage) {
    //       mythis.message = JSON.parse(storageMessage);
    //     } else {
    //       mythis.message = message;
    //     }
    //     // mythis.message = message;
    //     // localStorage.setItem('messageNav', JSON.stringify(message));


    //     const menu = localStorage.getItem('userMenu');
    //     if (!menu) {
    //       mythis.userService.getMenu().subscribe((data) => {
    //         mythis.userNemu = data;
    //         localStorage.setItem('userMenu', JSON.stringify(data));
    //         if (mythis.userNemu) {
    //           //
    //           //
    //           mythis.test(mythis.userNemu.userMenuNodes, mythis.currentUrl);
    //         }

    //       });
    //     } else {
    //       mythis.userNemu = JSON.parse(menu);
    //       mythis.test(mythis.userNemu.userMenuNodes, mythis.currentUrl);
    //     }

    //     // setTimeout(() => {
    //     //   if (mythis.userNemu) {
    //     //
    //     //
    //     //     mythis.test(mythis.userNemu.userMenuNodes, mythis.currentUrl);
    //     //   }
    //     // }, 500);

    //   }

    // )

    // this.data.activeComponents.subscribe(
    //   // message => this.message = message
    //   function name(currentactiveComponents) {
    //     mythis.currentactiveComponents = currentactiveComponents;
    //   }
    // )



    // this.data.currentUser.subscribe(
    //   function name(currentUserValue) {
    //       mythis.userName = currentUserValue;
    //   }
    // )

    // if (localStorage.hasOwnProperty('currentactiveComponents') == true){
    //   this.currentactiveComponents = JSON.parse(localStorage.getItem('currentactiveComponents'));
    //   this.currentMessageValue = JSON.parse(localStorage.getItem('currentMessageValue'));
    //   this.data.changeMessage3(this.currentactiveComponents, this.currentMessageValue);
    // }

  }

  setModuleId() {

    sessionStorage.setItem('moduleId', '0');
    sessionStorage.setItem('moduleName', '');
    this.generalService.moduleName.next('');
    this.router.navigateByUrl('/Training')
  }

  GoDashboard() {
    window.open(this.dashboardURL + "?uT=" + localStorage.getItem('token'), '_blank');
  }

  cancel() {
    this.modelChangePassword = {
      pass_current: '',
      pass: '',
      confirmPass: ''
    };
  }

  decodeBase64ToString(encodedString) {
    // Decodificar el Base64 al string original
    let decodedString = atob(encodedString);
    return decodedString;
  }

  encodeStringToBase64(string) {
    // Codificar el string a Base64
    let encodedString = btoa(string);
    return encodedString;
  }

  changePass() {

    let pass_current = this.decodeBase64ToString(localStorage.getItem('p455'))

    if(pass_current != this.modelChangePassword.pass_current){
      this.toast.error('Your current password is not correct');
      return
    }

    if(this.modelChangePassword.pass != this.modelChangePassword.confirmPass){
      this.toast.error('Passwords do not match')
      return
    }

    this.userService.changePassword(this.modelChangePassword.pass, this.ecomerceconcode).subscribe(result => {

      if (result.result == 1) {
        this.toast.success('Password changed successfully');
        let encode = this.encodeStringToBase64(this.modelChangePassword.pass)
        localStorage.setItem('p455', encode)
        this.popupChangePass = false
        this.modelChangePassword = {
          pass_current: '',
          pass: '',
          confirmPass: ''
        };
      } else {
        this.toast.error('Error');
      }
    });
  }
  GoToZD() {
    this.userService.getZDUserToken().subscribe(result => {

      window.open("https://cube-usa-edge.zendesk.com/access/jwt?jwt=" + result.ztoken, "_blank");

      // var wnd = window.open("https://cube-usa.zendesk.com/access/jwt?jwt=" + result.ztoken);
      // setTimeout(function () {
      //   wnd.close();
      //   window.open("https://cube-usa-edge.zendesk.com/", "_blank");
      // }, 500);

    });
  }
  test(array: any, link: string, resetbreadcrum = true, parentModule = {}) {
    if (resetbreadcrum) {
      this.generalService.breadcrum.next([]);
    }

    let finalLink = link.split('?')[0];

    for (let index = 0; index < array.length; index++) {
      const element = array[index];

      if (element.cubeLink == finalLink) {
        this.updateBreadCrum(parentModule);
        this.updateBreadCrum(element);
        sessionStorage.setItem('moduleId', element.id);
        this.generalService.moduleName.next(element.moduleName);

        return true;
      } else {
        if (element.userModules.length > 0) {
          // this.updateBreadCrum(element.moduleName);

          const stop = this.test(element.userModules, finalLink, false, element);

          if (stop == true) {
            return;
          }
        }
      }

    }

    return false;
  }

  updateBreadCrum(item: any) {
    const currentValue = this.generalService.breadcrum.value;
    const updatedValue = [...currentValue, item];
    this.generalService.breadcrum.next(updatedValue);
  }

  callModule(item: any) {
    sessionStorage.setItem('moduleId', item.id);
    sessionStorage.setItem('moduleName', item.moduleName);
    this.generalService.moduleName.next(item.moduleName);
    this.data.changeMessage({ id: item.id, moduleName: item.moduleName, cubeLink: item.cubeLink });

    this.router.navigateByUrl(item.cubeLink);
    $("#AB1").collapse("show");
  }

  deleteModule(item: any) {
    this.data.changeMessage2(item.id, item.cubeLink);
    this.router.navigate([this.currentactiveComponents[this.currentactiveComponents.length - 1]]);
  }

  mdSettings2() {
    this.popupSettings2 = true;
  }

  AccepTerms() {
    this.userService.acceptTerms(localStorage.getItem('email').toString()).subscribe(result => {
      localStorage.setItem('termaccepted', "1");
      window.location.reload();
    });
  }

  getMenuTop(){
    return -200
  }

  goToHome() {
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    this.router.onSameUrlNavigation = 'reload';
    this.router.navigateByUrl('/home');
  }

  asignarValue(event, input){
    this.template[input] = event.value
  }

  deleteUpdateTemplate(){
    let eliminarObject: boolean
    eliminarObject = false
    Array.prototype.forEach.call(this.arrayTemplate, template => {
      if(template.key == "Update Templates"){
        eliminarObject = true
      }
      if(eliminarObject == true){
        this.arrayTemplate.splice(1,1)
      }
    })
  }

  saveTemplate(comportamiento){
    let eliminarObject: boolean
    eliminarObject = false
    this.template['key'] = ''
    this.MapInformationService.insertUpdateEmailTemplate(this.template).subscribe(res => {
      Array.prototype.forEach.call(this.arrayTemplate, (template, i) => {
        console.log('aqui')
        console.log(template)
        if(template.key == "Update Templates"){
          eliminarObject = true
        }
        else if(template.key == "Custom Template"){
          if(comportamiento == 'update'){
            Array.prototype.forEach.call(template.items, item => {
              if(this.template.id == item.id){
                item['key'] = "Custom Template"
                item['subject'] = this.template.subject
                item['text'] = this.template.text
              }
            })
          }else if(comportamiento == 'new'){
            // this.MapInformationService.getEmailTemplate().subscribe((res: Array<any>) => {
            //   let templates = res
            //   let numTemplate = res.length
            //   let templateNew = templates[numTemplate - 1]
            //   let tempatePros = {
            //     id: templateNew['ID'],
            //     active: templateNew['ACTIVE'],
            //     createdate: templateNew['CREATEDATE'],
            //     createbyid: templateNew['CREATEBYID'],
            //     metadata: templateNew['METADATA'],
            //     subject: templateNew['SUBJECT'],
            //     tag: templateNew['TAG'],
            //     text: templateNew['TEXT'],
            //     updatedbyid: templateNew['UPDATEDBYID'],
            //     updateddate: templateNew['UPDATEDDATE'],
            //     key: 'Custom Template',
            //     method: 'InsertUpdateNotificationEmailTemplate'
            //   }
            //   template.items.push(tempatePros)
            //   let nuevosTemplates = template.items
            //   this.arrayTemplate[i].items = nuevosTemplates
            //   console.log(nuevosTemplates)
            //   console.log(this.arrayTemplate[i].items)
            // })
          }
        }
      })
      if(eliminarObject == true){
        this.arrayTemplate.splice(1,1)
      }
      // this.emailPopup = false;
      // this.popupVisibleTemplates = false;
      this.clearTemplate()
      // this.getTemplatesEmail()
      this.toast.success('Template updated successfully');
    })
  }

  selectTemplate(item){
    this.popupVisibleTemplates = false;
    this.template = item;
    let update =
    {
      key: 'Update Templates',
      items: [{subject: 'Update template'}],
    }
    let agregar: Boolean
    agregar = true
    Array.prototype.forEach.call(this.arrayTemplate, template => {
      if(template.key == "Update Templates"){
        console.log(template)
        agregar = false
      }
    })
    if(agregar == true){
      this.arrayTemplate.splice(1, 0, update)
    }
  }

  onItemDeleting(event){
    console.log(event)
    console.log('onItemDeleting')
  }

  onItemDeleted(event){
    console.log(event)
    console.log("onItemDeleted")
  }

  clearTemplate(){
    this.template = {
      id: 0,
      text: '',
      active: 1,
      subject: '',
      createdate: '',
      updateddate: '',
      updatedbyid: '',
      tag: '',
      metadata: '',
      method: 'InsertUpdateNotificationEmailTemplate'
    }
  }

  static getCartInfo(info) {
    let infoCart = []
    if (localStorage.getItem("cart") == undefined){
      infoCart = [localStorage.getItem("cart")]
      localStorage.setItem("cart", infoCart.toString())
    } else {
      infoCart = localStorage.getItem("cart").split(',')
      infoCart.push(info)
      localStorage.setItem("cart", infoCart.toString())
    }

    // for (let i = 0; i < localStorage.getItem("cart").split(',').length; i++) {
    //   if ()
    // }
    // this.numberCart = localStorage.getItem("cart").split(',')


    console.log(localStorage.getItem("cart").split(','))
    console.log("aqui")
  }

  Cart(){
    // if (this.logged){
      console.log("al carrito")
      this.router.navigateByUrl('/myCart');
    // } else {
    //   console.log("al login")
    //   this.showLoginModal = true
    // }
  }

  showLogin(){
    console.log("aqui")
    this.showLoginModal = true
  }

  SetTheme(theme){
    // console.log(theme)
    // this.ThemeService.setTheme(theme);
    this.themeName = theme;
    this.ThemeService.setTheme(theme);
  }

  cancelPopopChangePass(){
    console.log('alo??')
    this.modelChangePassword = {
      pass_current: '',
      pass: '',
      confirmPass: ''
    }
    this.popupChangePass = false
    this.password = 'password';
    this.password1 = 'password';
    this.password2 = 'password';
  }

  popupNewWorkOrder = false;
  linkCreateNewWorkOrder(){
    this.popupNewWorkOrder = true;
  } 

}
